import Service from '../service.js';

export default {
  components: {
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 9,
      total: 0,
      tabActiveType: '1',
      newsSecondTag: [],
      active: 0,
      newsList: [
        // {
        //   title: '中国共产党田东县第十五届纪律检查委员会第一次',
        //   time: '2022-03-11'
        // },
        // {
        //   title: '中国共产党田东县第十五届纪律检查委员会第一次',
        //   time: '2022-03-11'
        // },
        // {
        //   title: '中国共产党田东县第十五届纪律检查委员会第一次',
        //   time: '2022-03-11'
        // },
        // {
        //   title: '中国共产党田东县第十五届纪律检查委员会第一次',
        //   time: '2022-03-11'
        // },
        // {
        //   title: '中国共产党田东县第十五届纪律检查委员会第一次',
        //   time: '2022-03-11'
        // },
        // {
        //   title: '中国共产党田东县第十五届纪律检查委员会第一次',
        //   time: '2022-03-11'
        // },
        // {
        //   title: '中国共产党田东县第十五届纪律检查委员会第一次',
        //   time: '2022-03-11'
        // },
        // {
        //   title: '中国共产党田东县第十五届纪律检查委员会第一次',
        //   time: '2022-03-11'
        // },
        // {
        //   title: '中国共产党田东县第十五届纪律检查委员会第一次',
        //   time: '2022-03-11'
        // },
        // {
        //   title: '中国共产党田东县第十五届纪律检查委员会第一次',
        //   time: '2022-03-11'
        // }
      ],
      policyList: [
        // {
        //   data: '8',
        //   yese: '2025-01',
        //   body: '农业农村部最新发布《农村土地承包合同管理规划书》'
        // },
        // {
        //   data: '8',
        //   yese: '2025-01',
        //   body: '农业农村部最新发布《农村土地承包合同管理规划书》'
        // },
        // {
        //   data: '8',
        //   yese: '2025-01',
        //   body: '农业农村部最新发布《农村土地承包合同管理规划书》'
        // },
        // {
        //   data: '8',
        //   yese: '2025-01',
        //   body: '农业农村部最新发布《农村土地承包合同管理规划书》'
        // },
        // {
        //   data: '8',
        //   yese: '2025-01',
        //   body: '农业农村部最新发布《农村土地承包合同管理规划书》'
        // },
        // {
        //   data: '8',
        //   yese: '2025-01',
        //   body: '农业农村部最新发布《农村土地承包合同管理规划书》'
        // }
      ],
      partId: 1,
      news1: {},
      createdTimeDay: '',
      createdTimeYear: '',
      isPortal: true,
      tId1: '67bec61346cb25d6d284f5a8',
      tId2: '67bec61946cb25d6d284f5a9',
      skip: 0,
      limit: 10
    };
  },
  created() {
    this.getnews();
    this.getnews2();
  },
  methods: {

    handClick(url) {
      this.$router.push(url);
    },
    getnews() {
      Service.getnews({ catalogId: this.tId1}).then(res => {
        // this.detail = res;
        // this.slides = res.listImages;
        this. policyList=res.result;
        // console.log(res,'111');
      });
    },
    getnews2() {
      Service.getnews({ catalogId: this.tId2, limit: 9}).then(res => {
        this.newsList = res.result;
      });
    },
    getCreatedTimeDay (date) {
      const baseDateFilter = this.$options.filters['baseDate'];
      const baseDate = baseDateFilter(date);
      return baseDate.substring(8, 10);
    },
    getCreatedTimeYear (date) {
      const baseDateFilter = this.$options.filters['baseDate'];
      const baseDate = baseDateFilter(date);
      return baseDate.substring(0, 7);
    },
    getCreatedTimeYear2 (date) {
      const baseDateFilter = this.$options.filters['baseDate'];
      const baseDate = baseDateFilter(date);
      return baseDate.substring(0, 10);
    },
      // 详情
      toDetailPage(id) {
        this.$router.push({
            path: '/finance-insurance/InformationDetails',
            query: {
                id: id
            }
        });
        // console.log(id, '3231');
    }
  }

};
